// extracted by mini-css-extract-plugin
module.exports = {"container":"etf_container__33-ay","suffix":"etf_suffix__3KSNt","prefix":"etf_prefix__2-kE2","premium":"etf_premium__3jCyL"};